/** 识别模式 */
export enum OCRModeEnum {
  /** 人像面 */
  FRONT = 'front',
  /** 国徽面 */
  BACK = 'back',
  /** 连续识别，双面识别 */
  BOTH = 'both',
}

/** 身份证上传类型 */
export enum UploadTypeEnum {
  // 普通拍照
  Camera = 0,
  // 相册导入
  Album = 1,
  // 扫描识别
  SDKCamera = 2,
}

/** OCR识别状态 */
export enum UploadStatusEnum {
  /** 识别中 */
  PROCESSING = -1,
  /** 成功 */
  SUCCESS = 1,
  /** 双面超时 */
  TIMEOUT_BOTH = 2,
  /** 人像面超时 */
  TIMEOUT_FRONT = 3,
  /** 国徽面超时 */
  TIMEOUT_BACK = 4,
  /** API失败 */
  API_FAIL_BOTH = 5,
  /** 人像面API失败 */
  API_FAIL_FRONT = 6,
  /** 国徽面API失败 */
  API_FAIL_BACK = 7,
  /** 人像与国徽不匹配 */
  NOT_MATCH = 8,
  /** 通用失败 */
  FAIL = 9,
  /** 单面API失败（未知人像面与国徽面） */
  API_FAIL_UNKNOW = 10,
}

/** OSS上传场景 */
export enum UploadSceneEnum {
  /** 身份证正面 */
  ID_CARD_FRONT = 'user-id1',
  /** 身份证反面 */
  ID_CARD_BACK = 'user-id0',
}

/** 身份证上传处理流程类型 */
export enum UploadProcessTypeEnum {
  /** 普通拍摄模式（旧流程） */
  CAMERA = 0,
  /** 扫描识别模式（新流程） */
  SCAN = 1,
}

/** 身份证来源类型 */
export enum OCRDataSourceTypeEnum {
  /** 来自平台 */
  PLATFORM = 1,
  /** 需要手动录入 */
  MANUAL = 2,
  /** 来自金融（包括用户已上传或外采） */
  FINANCE = 3,
  /** 无法实名 流程中断（平台非身份证实名的用户) */
  BREAK = 4,
}

/** 身份证上传处理-流程来源: 0：授信；1：提现；2：我的；3：首页；4：其他 */
export enum OcrProcessSourceEnum {
  /** 授信 */
  CREDIT = 0,
  /** 提现 */
  WITHDRAW = 1,
  /** 我的 */
  MINE = 2,
  /** 首页 */
  HOME = 3,
  /** 其他 */
  OTHER = 4,
  /** 活动 */
  ACTIVITY = 5,
  /** ocr后流程 */
  OCR_AFTER = 6,
}

/** OCR信息带出情况 1: 二要素带出&OCR照片带出; 2: 二要素带出&OCR照片未带出；3: 不带出任何信息 */
export enum OcrMsgSourceEnum {
  /** 二要素带出&OCR照片带出 */
  BASIC_AND_PHOTO = 1,
  /** 二要素带出&OCR照片未带出 */
  ONLY_BASIC = 2,
  /** 不带出任何信息 */
  NOTHING = 3,
}

/** 识别操作来源 */
export enum OcrOperationSourceEnum {
  /** 常规 */
  GENERAL = 'ocrGeneralProcess',
  /** 现金活动 */
  CASH_REWARD = 'ocrCashReward',
}
